/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Verify_Email_TitleInputs */

const en_login_verify_email_title = /** @type {(inputs: Login_Verify_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify Your Email`)
};

const fr_login_verify_email_title = /** @type {(inputs: Login_Verify_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez Votre Email`)
};

const de_login_verify_email_title = /** @type {(inputs: Login_Verify_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen Sie Ihre E-Mail-Adresse`)
};

const it_login_verify_email_title = /** @type {(inputs: Login_Verify_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica la tua email`)
};

const ru_login_verify_email_title = /** @type {(inputs: Login_Verify_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердите свой адрес электронной почты`)
};

const es_login_verify_email_title = /** @type {(inputs: Login_Verify_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique su correo electrónico`)
};

const zh_cn2_login_verify_email_title = /** @type {(inputs: Login_Verify_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证您的电子邮件`)
};

const ja_login_verify_email_title = /** @type {(inputs: Login_Verify_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスを確認する`)
};

const hi_login_verify_email_title = /** @type {(inputs: Login_Verify_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना ईमेल सत्यापित करें`)
};

const pt_pt2_login_verify_email_title = /** @type {(inputs: Login_Verify_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique seu e-mail`)
};

/**
* | output |
* | --- |
* | "Verify Your Email" |
*
* @param {Login_Verify_Email_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_verify_email_title = /** @type {((inputs?: Login_Verify_Email_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Verify_Email_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_verify_email_title(inputs)
	if (locale === "de") return de_login_verify_email_title(inputs)
	if (locale === "it") return it_login_verify_email_title(inputs)
	if (locale === "ru") return ru_login_verify_email_title(inputs)
	if (locale === "es") return es_login_verify_email_title(inputs)
	if (locale === "zh-CN") return zh_cn2_login_verify_email_title(inputs)
	if (locale === "ja") return ja_login_verify_email_title(inputs)
	if (locale === "hi") return hi_login_verify_email_title(inputs)
	if (locale === "pt-PT") return pt_pt2_login_verify_email_title(inputs)
	return en_login_verify_email_title(inputs)
});